export const fixKpiTitle = (title) => {
  let titleRet = title;
  titleRet = titleRet?.replace("Faturado", "Facturado");
  titleRet = titleRet?.replace("Repartición de Bienes y Servicios", "División de bienes y servicios");
  titleRet = titleRet?.replace("Pedidos de proveedores residuales", "Pedidos de proveedor pendientes");
  titleRet = titleRet?.replace("Volumen de líneas y pedidos residuales", "Volumen de líneas y pedidos pendientes");
  return titleRet;
};